export const PAGE_SIZE = 10;

export const CONSULTATION_TYPES = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  HOME_VISIT: 'home_visit',
};

export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
  VERIFIED: 'verified',
};

export const MEMBERSHIP_TYPES = {
  BASIC: 'basic',
  PREMIUM: 'premium',
  GOLD: 'gold',
};

export const DATE_FORMATS = {
  DISPLAY: 'DD/MM/YYYY',
  API: 'YYYY-MM-DD',
  DATETIME: 'DD/MM/YYYY HH:mm',
};
